import React from "react";
import styles from "./Home.module.css";
import { Link } from "react-router-dom";
import homeVideo from "../../assets/4K Business Meeting Stock Footage _ Copyright Free Videos.mp4"
import { useSelector } from "react-redux";
import { motion } from "framer-motion";

export default function Home() {
  const { currentLocal } = useSelector((state) => state.currentLocal);
  return (
    <>
      <div
        className={
          currentLocal?.language == "English" ? styles.video_container : styles.ar_video_container
        }
        
      >
           <div className={styles.text_container} style={{zIndex:"10"}}>
                  <motion.div
        initial={{ opacity: 0, x: 100 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
        className="rightBox"
      >
          <h1>{currentLocal.general.headerTitle}</h1>
          <p>{currentLocal.general.headerPara} </p>
          <Link ro="/contact-us">{currentLocal.general.contact}</Link>
          </motion.div>
        </div>
        <div className={styles.overlay}></div>
     

        <video width="320" height="240" autoPlay={true}  loop={true} muted>
          <source
            src={homeVideo}
            type="video/mp4"
          />
          <source
            src={homeVideo}
            type="video/ogg"
          />
        </video>
      </div>
    </>

  );
}
